import { render, staticRenderFns } from "./DeleteRoleModal.vue?vue&type=template&id=281f4648&scoped=true"
import script from "./DeleteRoleModal.vue?vue&type=script&lang=js"
export * from "./DeleteRoleModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281f4648",
  null
  
)

export default component.exports